<template>
  <div class="slide" v-bind:class="{ opacityL: id !== activeId }">
    <q>{{quote}}</q>
    <div class="author">
      <div class="author_photo">
        <img class="h-full w-full rounded-full object-cover object-center"
             :src="require(`@/assets/img/landing_photos/testimonialAuthors/${image}`)" alt="">
      </div>
      <p class="">{{author}}</p>
    </div>
  </div>
</template>

<script>
  require('../../assets/css/index/client_reference_list_item.css');

  export default {
    name: 'ClientReferenceListItem',
    props: {
      id: Number,
      activeId: Number,
      quote: String,
      author: String,
      image: String
    }
  }
</script>
